var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},_vm._l((_vm.ratingList),function(item,index){return _c('svg',{key:index,class:_vm.getColor(item),attrs:{"fill":"currentColor","width":_vm.size,"height":_vm.size}},[_c('use',{staticClass:"ml-1",attrs:{"xlink:href":item}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }